import ApiService from "./ApiService";

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: "/admin/login",
    method: "post",
    data,
  }).then((res) => res?.data);
}

export async function apiVerifyAdminOtp(slug, code) {
  const safeSlug = encodeURIComponent(String(slug));
  const safeCode = encodeURIComponent(String(code));
  return ApiService.fetchData({
    url: `/admin/verify/${safeSlug}/${safeCode}`,
    method: "put",
  }).then((res) => res?.data);
}

export async function apiResendAdminOtp(slug) {
  const safeSlug = encodeURIComponent(String(slug));
  return ApiService.fetchData({
    url: `/admin/resend/${safeSlug}`,
    method: "put",
  }).then((res) => res?.data);
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "/sign-up",
    method: "post",
    data,
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: "/admin/logout",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: "/api/forgotPassword",
    method: "post",
    data,
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/reset-password",
    method: "post",
    data,
  });
}

export async function apiUpdateToken(data, token) {
  return ApiService.fetchData({
    url: "/admin/updateToken",
    method: "put",
    data,
    headers: token ? { Token: token } : undefined,
  }).then((res) => res?.data);
}
